const alertMixin = {
  methods: {
    successMessage(message) {
      this.$bvToast.toast(message, {
        variant: 'success',
        autoHideDelay: 5000,
        solid: false,
        noCloseButton: true,
        toaster: 'b-toaster-top-center',
      })
    },
    errorMessage(message) {
      this.$bvToast.toast(message, {
        variant: 'danger',
        autoHideDelay: 5000,
        solid: false,
        noCloseButton: true,
        toaster: 'b-toaster-top-center',
      })
    },
    warningMessage(message) {
      this.$bvToast.toast(message, {
        variant: 'info',
        autoHideDelay: 5000,
        solid: false,
        noCloseButton: true,
        toaster: 'b-toaster-top-center',
      })
    },
  },
}

export default alertMixin;